/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions
 */
export interface FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions
     */
    ZendeskEmbedKey?: string | null;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions(value: object): value is FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions {
    return true;
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions {
    return FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'ZendeskEmbedKey': json['ZendeskEmbedKey'] == null ? undefined : json['ZendeskEmbedKey'],
    };
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsToJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions {
    return FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ZendeskEmbedKey': value['ZendeskEmbedKey'],
    };
}

